<template>
  <div class="content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%;" class="dialog">
      <el-table-column prop="name" label="屏幕名称"> </el-table-column>
      <el-table-column prop="number" label="屏幕编号"> </el-table-column>
      <el-table-column prop="lamp_name" label="所属路灯"> </el-table-column>
      <el-table-column prop="screen_type" label="厂家">
        <template slot-scope="scope">
          {{ screenType[scope.row.screen_type] }}
        </template>
      </el-table-column>
      <el-table-column prop="ste" label="屏幕状态">
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pattern" label="设备模式">
        <template slot-scope="scope">
          <span>{{ patternType[scope.row.pattern] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
  </div>
</template>
<script>
import screenApi from "@/api/message/screenList"
export default {
  name: "screenList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      screenType: ['仰邦','熙讯','','卡莱特','诺瓦'],
      patternType: ["公网", "内网"],
      loading: false,
      dialogVisible: false,
      lampList: [],
      tableData: [],
      pageInfo: {
        group: this.groupId,
        page: 1,
        pageSize: 10
      },
      cnt_all: 0
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      screenApi.screenList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    }
  }
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
